'use client';
import styles from './styles.module.scss';
import { SylndrMapLocation } from '../../../../../public/Images';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from 'react-i18next';

const SylndrHubLocationButtonMobile = ({
    sylndrHubLocationButton,
}: {
    sylndrHubLocationButton: () => void;
}) => {
    const { t } = useTranslation();
    const img = SylndrMapLocation.src;
    return (
        <button
            onClick={() => sylndrHubLocationButton()}
            style={{ backgroundImage: `url(${img})` }}
            className={styles.map_container}
        >
            <div className={styles.expand_button}></div>
            <div className={styles.text_container}>
                <Typography variant="caption" color="#002D5D">
                    {`${t('SylndrHubLocationSubHeader')} ${t(
                        'mainShowroomAddress'
                    )}`}
                </Typography>
            </div>
        </button>
    );
};
export default SylndrHubLocationButtonMobile;
